@use "variables" as *;

.title {
  text-align: center;
  font-weight: bold;
  font-size: $fontSize-xs;
  height: $spacing-s;
}

.container {
  height: $pie-chart-size;
}

.chart {
  width: $pie-chart-size;
  height: $pie-chart-size;
}
